import * as actions from './bankMaster/actions'
import * as mutations from './bankMaster/mutations'
import * as getters from './bankMaster/getters'

import { dataProps } from './bankMaster/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/bankMaster.js